<div class="flex flex-wrap items-center justify-between gap-4">
  <form class="flex items-center gap-2" [formGroup]="form">
    <mat-form-field class="!min-w-[315px]" subscriptSizing="dynamic">
      <mat-label>{{ searchLabel() }}</mat-label>
      <input matInput formControlName="searchTerm" />
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="!max-w-[150px]">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-select-trigger>
          @if (form.controls.type.value) {
            <pr-referral-type-chip [type]="form.controls.type.value[0]" />
          }
        </mat-select-trigger>
        <mat-option>--</mat-option>
        @for (type of types; track type) {
          <mat-option [value]="[type]">
            <pr-referral-type-chip [type]="type" />
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="!max-w-[150px]">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status" multiple>
        @for (status of statuses; track status) {
          <mat-option [value]="status">
            {{ status | splitCamel | titlecase }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <span
      matBadgeColor="warn"
      matBadgeSize="small"
      [matBadge]="needsActionCount()"
      [matBadgeHidden]="needsActionCount() === 0"
    >
      <mat-slide-toggle
        [checked]="needsActionOnly()"
        (change)="toggleNeedsAction()"
      >
        Needs Action
      </mat-slide-toggle>
    </span>

    @if (hasActiveFilters()) {
      <button
        mat-icon-button
        matTooltip="Clear Filters"
        (click)="clearFilters()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </form>

  <pt-date-range-form [useRangePicker]="true" (changed)="updateDates($event)" />
</div>
